(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('[data-sort-menu]').forEach((menu) => {
    menu.querySelectorAll('[data-sort-option]').forEach((option) => {
      option.addEventListener('click', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', option.dataset.sortOption);
        window.location.assign(url.toString());
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuglia-coming-soon"]) return;
  try {
    
  document.querySelectorAll('.cuglia-coming-soon__form').forEach((form) => {
    const email = form.querySelector('[data-coming-soon-email]');
    const error = form.querySelector('[data-coming-soon-email-error]');

    if (!email || !error) return;

    const setEmailState = () => {
      const valid = email.validity.valid;
      email.setAttribute('aria-invalid', String(!valid));
      error.hidden = valid;
      return valid;
    };

    form.addEventListener('submit', (event) => {
      if (!setEmailState()) {
        event.preventDefault();
        email.focus();
      }
    });

    email.addEventListener('input', setEmailState);
  });

  document.querySelectorAll('[data-coming-soon-privacy-link]').forEach((link) => {
    const privacy = document.getElementById(link.hash.slice(1));

    if (!privacy) return;

    let lastFocusedElement;
    const closePrivacy = () => privacy.close();

    link.setAttribute('aria-haspopup', 'dialog');
    link.setAttribute('aria-controls', privacy.id);

    link.addEventListener('click', (event) => {
      event.preventDefault();
      lastFocusedElement = link;
      privacy.showModal();
      document.body.classList.add('cuglia-coming-soon-modal-open');
    });

    privacy.querySelector('[data-coming-soon-privacy-close]').addEventListener('click', closePrivacy);

    privacy.addEventListener('click', (event) => {
      if (event.target === privacy) closePrivacy();
    });

    privacy.addEventListener('close', () => {
      document.body.classList.remove('cuglia-coming-soon-modal-open');
      if (lastFocusedElement) lastFocusedElement.focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
document.querySelectorAll('[data-product-section]').forEach((section)=>{const select=section.querySelector('[data-variant-select]'),price=section.querySelector('[data-product-price]'),add=section.querySelector('[data-add]'),label=section.querySelector('[data-add-label]'),quantity=section.querySelector('[name="quantity"]'),variantLabel=section.querySelector('[data-variant-label]');const updateVariant=()=>{const option=select.options[select.selectedIndex],available=option.dataset.available==='true';price.innerHTML=`${option.dataset.compare?`<s>${option.dataset.compare}</s>`:''}<span>${option.dataset.price}</span>`;add.disabled=!available;label.textContent=available?'Aggiungi al carrello':'Esaurito';if(variantLabel)variantLabel.textContent=option.textContent.split(' — ')[0];section.querySelectorAll('[data-variant-option]').forEach(button=>button.setAttribute('aria-current',String(Number(button.dataset.variantOption)===select.selectedIndex)));};section.querySelectorAll('[data-variant-option]').forEach(button=>button.addEventListener('click',()=>{select.selectedIndex=Number(button.dataset.variantOption);updateVariant();button.closest('details').removeAttribute('open');}));section.querySelectorAll('[data-quantity]').forEach(button=>button.addEventListener('click',()=>quantity.value=Math.max(1,Number(quantity.value||1)+Number(button.dataset.quantity))));const slides=[...section.querySelectorAll('[data-gallery-slide]')],thumbnails=[...section.querySelectorAll('[data-gallery-thumbnail]')];let active=0;const showSlide=(index)=>{active=(index+slides.length)%slides.length;slides.forEach((slide,position)=>slide.classList.toggle('is-active',position===active));thumbnails.forEach((thumbnail,position)=>{thumbnail.classList.toggle('is-active',position===active);thumbnail.setAttribute('aria-current',String(position===active));});};thumbnails.forEach(thumbnail=>thumbnail.addEventListener('click',()=>showSlide(Number(thumbnail.dataset.galleryThumbnail))));const previous=section.querySelector('[data-gallery-previous]'),next=section.querySelector('[data-gallery-next]');if(previous)previous.addEventListener('click',()=>showSlide(active-1));if(next)next.addEventListener('click',()=>showSlide(active+1));});

  } catch(e) { console.error(e); }
})();
})();
